import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { NotificationProvider } from './contexts/NotificationContext'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './components/Login'
import Register from './components/Register'
import ForgotPassword from './components/ForgotPassword'
import Dashboard from './components/Dashboard'
import UpiQrGenerator from './components/UpiQrGenerator'
import FirebaseUsers from './components/FirebaseUsers'
import MqttCommands from './components/MqttCommands'
import NotificationCenter from './components/NotificationCenter'
import NotificationToast from './components/NotificationToast'
import GlobalMonitoring from './components/GlobalMonitoring'
import Navbar from './components/Navbar'
import LoadingSpinner from './components/LoadingSpinner'
import Reports from './components/Reports'
import ReplenishInterface from './components/ReplenishInterface'
import ReplenishWorkerLanding from './components/ReplenishWorkerLanding'
import SmartRouteRedirect from './components/SmartRouteRedirect'
import AppErrorBoundary from './components/AppErrorBoundary'

function App() {
  const { currentUser, loading } = useAuth()

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className="App">
      <AppErrorBoundary>
        <NotificationProvider>
          {currentUser && <GlobalMonitoring />}
          <Routes>
          <Route 
            path="/login" 
            element={currentUser ? <SmartRouteRedirect /> : <Login />} 
          />
          <Route 
            path="/register" 
            element={currentUser ? <SmartRouteRedirect /> : <Register />} 
          />
          <Route 
            path="/forgot-password" 
            element={currentUser ? <SmartRouteRedirect /> : <ForgotPassword />} 
          />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute redirectReplenishOnly>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/upi-qr" 
            element={
              <ProtectedRoute>
                <UpiQrGenerator />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/firebase-users" 
            element={
              <ProtectedRoute>
                <FirebaseUsers />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/mqtt" 
            element={
              <ProtectedRoute>
                <MqttCommands />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/notifications" 
            element={
              <ProtectedRoute>
                <NotificationCenter />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/reports" 
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/replenish-worker" 
            element={
              <ProtectedRoute>
                <ReplenishWorkerLanding />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/replenish/:machineId" 
            element={
              <ProtectedRoute>
                <ReplenishInterface />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/" 
            element={currentUser ? <SmartRouteRedirect /> : <Navigate to="/login" />} 
          />
          </Routes>
          <NotificationToast />
        </NotificationProvider>
      </AppErrorBoundary>
    </div>
  )
}

export default App
